<style socped>
  .doc-tabs .ivu-tabs-tabpane{padding-top: 25px;}
  .layout-activity-tabs .doc-tabs .ivu-tabs-nav-container{
    padding-left: 0;
  }
</style>
<template>
  <content-layout :title="title" :head-image="headImage" :tabs="tabs" v-model="activeTab" :spin-show="spinShow">
    <div class="icons" slot="icons">
      <!-- <button style="button" class="layout-icon">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiajianzujianjiahao"></use>
        </svg>
      </button> -->
    </div>
    <div class="activity-item mgui-container" slot="/documents">
      <div class="filter-row">
        <ButtonGroup>
          <Button
            :type="filterItem.type=='yes'?'info':'default'"
            @click="filterItem.type = 'yes'">
            已上架
          </Button>
          <Button
            :type="filterItem.type=='check'?'info':'default'"
            v-if="$menu.isPower('documents', 'check')"
            @click="filterItem.type = 'check'">
            待审核
          </Button>
          <Button
            :type="filterItem.type=='no'?'info':'default'"
            @click="filterItem.type = 'no'">
            已售罄
          </Button>
        </ButtonGroup>
        <Input placeholder="商品名称" style="display: inline-block;width: 160px"></Input>
        <Button icon="search" type="default">筛选</Button>
      </div>
      <loading :visible="documents.length == 0" :icon="loadIcon" :text="loadTips"></loading>
      <Table :columns="docColumns" :data="documents" v-if="documents.length > 0"></Table>
      <div class="pager" v-if="documents.length>0">
        <Page :total="allPage.total" :page-size="15" @on-change="pagerAllChange" show-elevator></Page>
      </div>
    </div>
    <div class="activity-item mgui-container" slot="/documents/post">
      <document-post :id.sync="docId"></document-post>
    </div>
  </content-layout>
</template>

<script>
  import { post, fetch } from '../fetch/api'
  // import {formatDate} from '../util/filter'

  export default {
    name: 'CostsPage',
    components: {
      DocumentPost: resolve => { require(['../components/DocumentPostComponent'], resolve) },
      Loading: resolve => { require(['../components/LoadingComponent'], resolve) },
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) }
    },
    data () {
      return {
        filterItem: {
          type: 'yes'
        },
        tabs: [],
        activeTab: '/documents',
        title: '商品管理',
        spinShow: false,
        headImage: '/static/images/bg/money.jpeg',
        docId: 0,
        documents: [],
        docColumns: [
          {title: '#', width: 60, key: 'goods_id'},
          {title: '商品名称', key: 'title'},
          {title: '浏览量', width: 80, align: 'center', key: 'view'},
          {title: '更新时间', width: 100, key: 'updated_at'},
          {
            title: '操作',
            key: 'action',
            width: 150,
            align: 'right',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.show(params.row)
                    }
                  }
                }, '查看'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.remove(params.index)
                    }
                  }
                }, '删除')
              ])
            }
          }
        ],
        loadTips: '',
        loadIcon: 'refresh',
        costsTips: '',
        costsCountVisible: false,
        allPage: {
          total: 0,
          page: 1
        }
      }
    },
    watch: {
      $route (to) {
        this.routeChange(to)
      },
      'filterItem.type' () {
        this.fetchDocuments()
      }
    },
    methods: {
      routeChange (route) {
        let action = route.params.action
        if (action === undefined) {
          this.activeTab = '/documents'
          // this.fetchCosts()
          // this.fetchDocuments()
        } else if (action === 'post') {
          this.activeTab = '/documents/post'
        }
      },
      fetchDocuments () {
        this.spinShow = true
        this.documents = []
        this.loadIcon = 'refresh'
        this.loadTips = '加载中请稍等...'
        let params = JSON.parse(JSON.stringify(this.filterItem))
        params.page = this.allPage.page
        if (params.department_id !== null) params.department_id = JSON.stringify(params.department_id)

        fetch('goods', {params: params}).then(res => {
          if (res.data.length === 0) {
            this.loadIcon = 'alert-circled'
            this.loadTips = '暂无记录'
          } else {
            this.documents = res.data
            this.allPage.total = res.total
          }
          this.spinShow = false
        }).catch(() => {
          this.loadTips = '加载失败，请重试'
          this.spinShow = false
        })
      },
      submitCosts (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            post('documents/add', this.formItem).then(res => {
              if (res.status === 'ok') {
                this.$Message.success('添加成功')
                this.activeTab = 'lists'
                // this.fetchCosts()
                // this.formItem = JSON.parse(JSON.stringify(formData))
                this.$refs[name].resetFields()
              }
            })
          }
        })
      },
      setTabs () {
        if (this.$menu.isPower('cost', 'all')) this.fetchDocuments()
        this.tabs = [
          {'title': '商品', 'key': '/documents', 'visible': true},
          {'title': '发布商品', 'key': '/documents/post', 'visible': this.$menu.isPower('documents', 'post')}
        ]
      },
      filterCosts () {
        this.fetchDocuments()
      },
      pagerAllChange (page) {
        this.allPage.page = page
        this.fetchDocuments()
      },
      show (row) {
        this.docId = row.goods_id
        this.$router.push({'path': '/documents/post', 'query': {goods_id: row.goods_id}})
      },
      remove () {

      }
    },
    mounted () {
      this.routeChange(this.$route)
      if (this.$route.query.goods_id) this.docId = this.$route.query.goods_id
      setTimeout(() => {
        this.setTabs()
      }, 400)
    }
  }
</script>
